export enum SlideIndexs {
  Welcome = 0,
  FirstName = 1,
  LastName = 2,
  Email = 3,
  Phone = 4,
  Confirm = 5,
  SignUpSuccess = 6,
  RetrySendReceipt = 7,
  ContactSent = 8,
  ThankYou = 9,
}

export enum Modals {
  Policy = "policy",
  ContactOptions = "contact-options",
}
